module.exports = (
  endpoints,
  ResourceConfig,
  ConcurrentResource,
  ) ->

  actions = ResourceConfig.actions
  byid = ResourceConfig.byid
  paginated_page_actions = JSON.parse(JSON.stringify(actions))
  paginated_page_actions.query =
    method: 'GET'
    isArray: false

  @WorkflowTemplate = ConcurrentResource("#{endpoints.WorkflowTemplate}:id/", byid, actions)
  @Workflow = ConcurrentResource("#{endpoints.Workflow}:id/", byid, actions)
  @WorkflowEncryptedMetadata = ConcurrentResource("#{endpoints.WorkflowEncryptedMetadata}:id/", byid, actions)
  @WorkflowStepConfig = ConcurrentResource("#{endpoints.WorkflowStepConfig}:id/", byid, actions)
  @StepModifier = ConcurrentResource("#{endpoints.StepModifier}:id/", byid, actions)
  @WorkflowStepTemplate = ConcurrentResource("#{endpoints.WorkflowStepTemplate}:id/", byid, actions)
  @WorkflowStep = ConcurrentResource("#{endpoints.WorkflowStep}:id/", byid, actions)
  @WorkflowStepIteration = ConcurrentResource("#{endpoints.WorkflowStepIteration}:id/", byid, actions)
  @ManualWorkflowStepIteration = ConcurrentResource("#{endpoints.ManualWorkflowStepIteration}:id/", byid, actions)
  @WorkflowStepIterationSearch = ConcurrentResource("#{endpoints.WorkflowStepIterationSearch}:id/", byid, actions)
  @WorkflowStepIterationSearchResult = ConcurrentResource("#{endpoints.WorkflowStepIterationSearchResult}:id/", byid, actions)
  @ResearchRequest = ConcurrentResource("#{endpoints.ResearchRequest}:id/", byid, actions)
  @ResearchRequestMessage = ConcurrentResource("#{endpoints.ResearchRequestMessage}:id/", byid, actions)
  @Processes = ConcurrentResource("#{endpoints.Processes}:id/", byid, actions)
  @State = ConcurrentResource("#{endpoints.State}:id/", byid, actions)
  @Project = ConcurrentResource("#{endpoints.Project}:id/", byid, actions)
  @ProjectEncryptedMetadata = ConcurrentResource("#{endpoints.ProjectEncryptedMetadata}:id/", byid, actions)
  @ProjectStarredDocument = ConcurrentResource("#{endpoints.ProjectStarredDocument}:id/", byid, actions)
  @Comment = ConcurrentResource("#{endpoints.Comment}:id/", byid, actions)
  @Language = ConcurrentResource("#{endpoints.Language}:id/", byid, actions)
  @Country = ConcurrentResource("#{endpoints.Country}:id/", byid, actions)
  @Category = ConcurrentResource("#{endpoints.Category}:id/", byid, actions)
  @Collection = ConcurrentResource("#{endpoints.Collection}:id/", byid, actions)
  @Engine = ConcurrentResource("#{endpoints.Engine}:id/", byid, actions)
  @AdverseTerms = ConcurrentResource("#{endpoints.AdverseTerms}:id/", byid, actions)
  @Search = ConcurrentResource("#{endpoints.Search}:id/", byid, actions)
  @SearchWorker = ConcurrentResource( "#{endpoints.SearchWorker}:id/", byid, actions)
  @SearchResult = ConcurrentResource("#{endpoints.SearchResult}:id/", byid, actions)
  @SearchTermTypes = ConcurrentResource("#{endpoints.SearchTermTypes}:id/", byid, actions)
  @ManagedUser = ConcurrentResource("#{endpoints.ManagedUser}:id/", byid, paginated_page_actions)
  @SimpleManagedUser = ConcurrentResource("#{endpoints.SimpleManagedUser}:id/", byid, actions)
  @ManagedClient = ConcurrentResource("#{endpoints.ManagedClient}:id/", byid, actions)
  @ManagedGroup = ConcurrentResource("#{endpoints.ManagedGroup}:id/", byid, actions)
  @ManagedGroupUsers = ConcurrentResource("#{endpoints.ManagedGroup}:group/users/:id/", {id: '@id', group: '@group'}, actions)
  @AssignProject = ConcurrentResource("#{endpoints.AssignProject}:id/", byid, actions)
  @Users = ConcurrentResource("#{endpoints.Users}:id/", byid, actions)
  @Preferences = ConcurrentResource("#{endpoints.Preferences}:id/", byid, actions)
  @ProjectExports = ConcurrentResource("#{endpoints.ProjectExports}:id/", byid, actions)
  @ProjectExportsDownloads = ConcurrentResource("#{endpoints.ProjectExportsDownloads}:id/", byid, actions)
  @ProjectPagination = ConcurrentResource("#{endpoints.ProjectPagination}:id/", byid, paginated_page_actions)
  @MonitoringSubjects = ConcurrentResource("#{endpoints.MonitoringSubjects}:id/", byid, actions)
  @CustomSource = ConcurrentResource("#{endpoints.CustomSource}:id/", byid, actions)
  @CuratedSource = ConcurrentResource("#{endpoints.CuratedSource}:id/", byid, actions)

  @BulkUpload = ConcurrentResource("#{endpoints.BulkUpload}:id/", byid, paginated_page_actions)
  @BulkUploadMappings = ConcurrentResource("#{endpoints.BulkUploadMappings}:id/", byid, paginated_page_actions)
  @MonitoringSubjectAlerts = ConcurrentResource("#{endpoints.MonitoringSubjects}:subject/alerts/:id/", {id: '@id', subject: '@subject'}, actions)
  @ActionLog = ConcurrentResource("#{endpoints.ActionLog}", {project: '@project'}, paginated_page_actions)
  @AuditTrail = ConcurrentResource("#{endpoints.AuditTrail}", {project: '@project'}, paginated_page_actions)
  @Entity = ConcurrentResource("#{endpoints.Entity}:id/", byid, paginated_page_actions)
  @FactTemplates = ConcurrentResource("#{endpoints.FactTemplates}", {})
  @IDDReport = ConcurrentResource("#{endpoints.IDDReport}", {})
  @FactivaToken = ConcurrentResource("#{endpoints.FactivaToken}", {},
    get:
      method: 'GET'
      cache: false
    put:
      method: 'PUT'
      cache: false
  )
  @CSRF = ConcurrentResource("#{endpoints.CSRF}", {}, {
    get: {method: 'GET'}
  })
  @StickyMessage = ConcurrentResource("#{endpoints.StickyMessage}", {})
  @NamePseudonyms = ConcurrentResource("#{endpoints.NamePseudonyms}", {})
  @RunIteration = ConcurrentResource("#{endpoints.RunIteration}:id", byid, actions)
  @City = ConcurrentResource("#{endpoints.City}:id", byid, paginated_page_actions)
  @Subdivision = ConcurrentResource("#{endpoints.Subdivision}", byid, paginated_page_actions)
  @ExecutiveSummary = ConcurrentResource("#{endpoints.Project}:id/executive_summary/", byid,
    get:
      method: 'GET'
      cache: false
  )
  return # This function is a constructor. Stop coffeescript from returning anything
